import { createSlice } from "@reduxjs/toolkit";
import avatarImg from "assets/images/user-avatar.png";

export const authorizationSlice = createSlice({
	name: "authorization",
	initialState: {
		authorization: {
			token: "",
			imagePath: avatarImg,
			hasServices: [],
			coins: 0,
			loginTimes: 0,
			numberOfNewProjects: 0,
			isTermsVisible: true,
		},
	},
	reducers: {
		login: (state, action) => {
			state.authorization = action.payload;
		},
		logout: (state, action) => {
			state.authorization = null;
		},
		changeAuthImg: (state, action) => {
			state.authorization.imagePath = action.payload;
		},
		changeUserData: (state, action) => {
			state.authorization = { ...state.authorization, ...action.payload };
		},
		changeAuthServiceType: (state, action) => {
			state.authorization.hasServices = action.payload;
		},
		changeAuthCoins: (state, action) => {
			state.authorization.coins = action.payload;
		},
		changeloginTimes: (state, action) => {
			state.authorization.loginTimes = action.payload;
		},
		chageNumberOfNewProjects(state, action) {
			if (action.payload >= 0) {
				state.authorization.numberOfNewProjects = action.payload;
			}
		},
		changeIsTermsVisible(state, action) {
			state.authorization.isTermsVisible = false;
		},
		changeTokens(state, action) {
			// state.authorization.coins = action.payload;
			state.authorization = { ...state.authorization, coins: action.payload };
		},
	},
});

const { reducer, actions } = authorizationSlice;
export const {
	login,
	logout,
	changeAuthImg,
	changeAuthServiceType,
	changeAuthCoins,
	changeEmail,
	changeUserData,
	changeloginTimes,
	chageNumberOfNewProjects,
	changeIsTermsVisible,
	changeTokens,
} = actions;
export default reducer;
